/* Nexlane — motion + mobile video weight
 *
 * 1. Scroll reveal (transform only — see note below)
 * 2. Mobile hero-video rendition swap
 *
 * DESIGN RULE for the reveal: it must fail OPEN. A reveal that relies on
 * JavaScript to make content visible will hide the page if anything goes
 * wrong. This version only offsets sections by 24px, so the worst possible
 * failure is content sitting slightly low. Never add opacity here.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 749;
  var HARD_REVEAL_MS = 1200;

  /* ------------------------------------------- mobile video rendition swap
   *
   * Shopify transcodes every uploaded video into several renditions. The
   * theme serves HD-720p at 4.5Mbps (2.8MB for a 5s clip). The SD-480p
   * rendition at 1.5Mbps is roughly a third of that and is indistinguishable
   * in a 375px-wide hero.
   *
   * We rewrite the source URL rather than hiding the slide, so phone users
   * still get the video. If the SD rendition 404s for any reason, the error
   * handler restores the original URL.
   */
  function useLighterVideo() {
    if (window.innerWidth > MOBILE_MAX) return;

    var videos = document.querySelectorAll('slideshow-slide video');

    for (var i = 0; i < videos.length; i++) {
      (function (video) {
        var sources = video.querySelectorAll('source');
        var swapped = false;
        var originals = [];

        for (var j = 0; j < sources.length; j++) {
          var src = sources[j].getAttribute('src') || '';
          originals.push(src);
          // Shopify rendition pattern: <id>.HD-720p-4.5Mbps-<n>.mp4
          var lighter = src.replace(/HD-\d+p-[\d.]+Mbps/, 'SD-480p-1.5Mbps');
          if (lighter !== src) {
            sources[j].setAttribute('src', lighter);
            swapped = true;
          }
        }

        if (!swapped) return;

        // If the lighter rendition fails, put the originals back once.
        var restored = false;
        video.addEventListener('error', function restore() {
          if (restored) return;
          restored = true;
          var s = video.querySelectorAll('source');
          for (var k = 0; k < s.length; k++) s[k].setAttribute('src', originals[k]);
          try { video.load(); video.play(); } catch (e) { /* non-fatal */ }
        }, true);

        try {
          video.load();
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked; poster shows */ });
        } catch (e) { /* non-fatal */ }
      })(videos[i]);
    }
  }

  /* -------------------------------------------------------- scroll reveal */

  function revealAll() {
    var hidden = document.querySelectorAll('.nx-reveal:not(.nx-in)');
    for (var i = 0; i < hidden.length; i++) hidden[i].classList.add('nx-in');
  }

  function initReveal() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('#MainContent > .shopify-section, #MainContent > section');
    if (!sections.length) return;

    for (var i = 1; i < sections.length; i++) sections[i].classList.add('nx-reveal');

    var observer;
    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nx-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 });
    } catch (e) {
      revealAll();
      return;
    }

    document.querySelectorAll('.nx-reveal').forEach(function (el) { observer.observe(el); });

    setTimeout(revealAll, HARD_REVEAL_MS);
    window.addEventListener('load', function () { setTimeout(revealAll, 400); });
  }

  function init() {
    useLighterVideo();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
